import React from 'react';
import clsx from 'clsx';
import css from './H2.module.css';
import { TextBaseProps } from '../textBase/TextBase';

const H2: React.FC<TextBaseProps> = (props: TextBaseProps) => {
  return <h2 className={clsx(css.h2, props.className)}>{props.text}</h2>;
};

// eslint-disable-next-line react-refresh/only-export-components
export default H2;
